import { i18n } from "@lingui/core";
import { Badge } from "@warp-ds/components/react/badge";
import { WIcon } from "@warp-ds/components/react/icon";
import { Button } from "@warp-ds/react";

export type HeaderProps = Record<string, never>;

export function Header() {
	const handleBackClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
		e.preventDefault();
		window.history.back();
	};

	return (
		<div className="relative self-stretch px-48">
			<header className="flex flex-col items-center text-center py-6">
				<span className="inline-flex items-center gap-8">
					<a
						className="flex items-center absolute left-0 bg-transparent border-none cursor-pointer p-0"
						onClick={handleBackClick}
					>
						<Button
							link
							aria-label={i18n.t({
								id: "explore.back.button",
								message: "Back",
							})}
							className="flex items-center s-icon mr-4"
						>
							<WIcon name="ChevronLeft" size="small" locale={i18n.locale} />
						</Button>
						<span className="text-body s-text-link">
							{i18n.t({
								id: "explore.back.button",
								message: "Back",
							})}
						</span>
					</a>
					<span
						className="t2"
						style={{
							background:
								"linear-gradient(105deg, var(--w-s-color-text-link) 15.06%, var(--w-s-color-background-secondary) 118.85%)",
							backgroundClip: "text",
							WebkitTextFillColor: "transparent",
						}}
					>
						{i18n.t({
							id: "explore.header.title",
							message: "Explore",
						})}
					</span>
					<Badge variant="info">
						{i18n.t({
							id: "explore.header.badge",
							message: "Beta",
						})}
					</Badge>
				</span>
				<p className="text-preamble mt-12">
					{i18n.t({
						id: "explore.prompt.subtitle",
						message: "Find your next recommerce deal with AI",
					})}
				</p>
			</header>
		</div>
	);
}
